if (!customElements.get('galfer-wheel-addon')) {
  class GalferWheelAddon extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId);
      this.productRoot = this.closest('.js-product') || this.closest('.shopify-section');
      if (!this.form || !this.productRoot) return;

      try {
        const config = JSON.parse(this.querySelector('[data-galfer-config]').textContent);
        this.wheelVariantIds = new Set(config.wheelVariantIds.map(String));
        this.packVariantIds = new Set(config.packVariantIds.map(String));
      } catch (error) {
        return;
      }

      this.inputs = [...this.querySelectorAll('input[type="radio"]')];
      this.checkoutVisibility = new WeakMap();
      this.onVariantChange = (event) => {
        if (event.detail?.form === this.form) {
          this.sync(event.detail.variant?.id ?? '');
        }
      };
      this.onSelectionChange = () => this.sync();
      this.productRoot.addEventListener('on:variant:change', this.onVariantChange);
      this.addEventListener('change', this.onSelectionChange);
      this.sync();
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('on:variant:change', this.onVariantChange);
      this.removeEventListener('change', this.onSelectionChange);
      this.restoreCheckout();
    }

    getSelectedVariantId(wheelVariantId = this.form?.querySelector('[name="id"]')?.value) {
      if (!this.wheelVariantIds?.has(String(wheelVariantId))) return '';
      const selected = this.inputs?.find((input) => input.checked && !input.disabled)?.value;
      return this.packVariantIds?.has(selected) ? selected : '';
    }

    sync(wheelVariantId = this.form.querySelector('[name="id"]')?.value) {
      const eligible = this.wheelVariantIds.has(String(wheelVariantId));
      if (!eligible) {
        this.inputs.forEach((input) => { input.checked = input.value === ''; });
      }
      this.inputs.forEach((input) => { input.disabled = !eligible; });
      this.hidden = !eligible;
      // Accelerated checkout bypasses the normal multi-item form submission.
      const checkout = this.form.closest('product-form')?.querySelector('.product-info__dynamic-checkout-button');
      if (checkout) {
        if (!this.checkoutVisibility.has(checkout)) this.checkoutVisibility.set(checkout, checkout.hidden);
        checkout.hidden = this.getSelectedVariantId(wheelVariantId) ? true : this.checkoutVisibility.get(checkout);
        this.checkout = checkout;
      }
    }

    restoreCheckout() {
      if (this.checkout && this.checkoutVisibility?.has(this.checkout)) {
        this.checkout.hidden = this.checkoutVisibility.get(this.checkout);
      }
    }
  }
  customElements.define('galfer-wheel-addon', GalferWheelAddon);
}
